import { FormattedMessage, useIntl } from 'react-intl'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { SecondaryInfo } from 'features/App/components/SecondaryInfo'
import { ConciliationStatus } from 'features/Inventories/components/ConciliationStatus'
import { OrderItems } from 'features/Inventories/components/OrderItems'
import { OrderStatus } from 'features/Inventories/components/OrderStatus'

export const InboundOrdersList = ({ orders = [] }): TSFixMe => {
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="spanish.dictionary.id" defaultMessage="Id" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.status" defaultMessage="Estado" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.dictionary.createdAt" defaultMessage="Fecha de creación" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.inventories.inbounds.list.items" defaultMessage="Productos" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.inventories.inbounds.list.origin" defaultMessage="Origen" />
            </Th>

            <Th>
              <FormattedMessage id="spanish.inventories.inbounds.list.user" defaultMessage="Agregado por" />
            </Th>

            <Th>
              <FormattedMessage
                id="spanish.inventories.inbounds.list.conciliationStatus"
                defaultMessage="Estado de conciliación"
              />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {orders.map((order: TSFixMe): TSFixMe => {
            return (
              <Tr key={order.id}>
                <Td>
                  <CopyToClipboardWrapper>
                    <div>{order.id.substring(0, 8)}</div>

                    <CopyToClipboard str={order.id} />
                  </CopyToClipboardWrapper>
                </Td>

                <Td>
                  <OrderStatus status={order.status} />
                </Td>

                <Td>
                  <FormattedDate intl={intl} value={order.createdAt} month="2-digit" day="2-digit" year="numeric" />

                  <SecondaryInfo>
                    <FormattedTimeByDate intl={intl} date={order.createdAt} />
                  </SecondaryInfo>
                </Td>

                <Td>
                  <OrderItems order={order} />
                </Td>

                <Td>{order.origin && order.origin.id ? order.origin.name : order.supplier}</Td>

                <Td>
                  {order.createdBy.firstName} {order.createdBy.lastName} ({order.createdBy.username})
                </Td>

                <Td>{order.conciliationStatus ? <ConciliationStatus status={order.conciliationStatus} /> : 'N/A'}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
